<div
  class="lm-modal__container"
  [ngClass]="{
    'lm-modal__container--mobile-full': modalOptions.isNonSwiperModal && isMobile,
    'lm-modal__container--disabled-max-height': modalOptions.disableMaxHeightChanges && isMobile
  }"
  [attr.data-testid]="getTestId('modal')"
>
  <div
    [attr.class]="'lm-modal__wrapper' + (modalOptions.modalSize ? ' ' + modalOptions.modalSize : '')"
    [ngClass]="{
      'lm-modal__container--dark': darkTheme,
      'lm-modal__wrapper--centred': modalOptions.isNonSwiperModal,
      '!h-full': modalOptions.canGoFullScreenOnMobile && isMobile
    }"
  >
    <ng-container *ngIf="!isMobile || (isMobile && modalOptions.isNonSwiperModal)">
      <button
        *ngIf="modalOptions.showCloseBtn"
        class="lm-modal__close"
        [attr.data-testid]="getTestId('close-btn')"
        [ngClass]="{ 'lm-modal__close--full-modal': isMobile && modalOptions.isNonSwiperModal }"
        (click)="close()"
      >
        <ng-container *ngTemplateOutlet="closeXIcon" />
      </button>
    </ng-container>

    <div
      #modalContent
      [attr.class]="
        'lm-modal__content' +
        (modalOptions.fullScreen && modalOptions.modalContentAdditionalCssClass
          ? ' full-screen' + modalOptions.modalContentAdditionalCssClass
          : '')
      "
      [ngClass]="{
        '!h-full !max-h-full !py-0': modalOptions.canGoFullScreenOnMobile && isMobile,
        'full-screen': modalOptions.fullScreen && !modalOptions.modalContentAdditionalCssClass,
        'slide-up-animation': isMobile && !modalOptions.isNonSwiperModal,
        'lm-modal__content--dark': darkTheme,
        'lm-modal__content--centred': modalOptions.isNonSwiperModal,
        'lm-modal__content--mobile-centred': modalOptions.isNonSwiperModal && isMobile
      }"
      [ngStyle]="{
        maxHeight: !isMobile && !modalOptions.disableMaxHeight ? innerHeight() + 'px' : '',
        bottom: bottomPosition + 'px'
      }"
      (window:resize)="innerHeight()"
      (scroll)="onModalContentScroll()"
    >
      <ng-container
        *ngIf="isMobile && modalOptions.fullScreen && modalOptions.showCloseBtn && !modalOptions.isNonSwiperModal"
      >
        <div class="close__container">
          <div class="close-btn__wrapper">
            <button class="lm-modal__close__mobile" (click)="close()">
              <i class="fa-regular fa-xmark"></i>
            </button>
          </div>
        </div>
      </ng-container>
      <div
        *ngIf="isMobile && !modalOptions.fullScreen && modalOptions.showCloseBtn && !modalOptions.isNonSwiperModal"
        [attr.class]="'modal__swiper'"
        [ngClass]="{ 'lm-modal__content--dark': darkTheme }"
        (panup)="swipeUp($event)"
        (pandown)="swipeDown($event)"
        (panend)="panEnd($event)"
      >
        <button
          class="line-swiper"
          [ngClass]="{
            'line-swiper--hidden': isMobile && modalOptions.fullScreen,
            'line-swiper--dark': darkTheme
          }"
        ></button>
      </div>

      <ng-content></ng-content>
    </div>
  </div>
</div>
<div class="lm-modal__background"></div>

<ng-template #closeXIcon>
  <svg height="1em" viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg">
    <!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
    <path
      d="M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"
      fill="#4b4b4d"
    />
  </svg>
</ng-template>
